import { useState, useEffect } from "react"
import {
  isLatLngQueryString,
  createGeolocationFeature,
} from "utils/geolocation"
import { useQuery } from "./useQuery"
import {
  get as getPersistValue,
  set as setPersistValue,
} from "utils/persist_store"

const VENUE_DEVICE_LOCATION_KEY = "venue_device_location"
const VENUE_DEVICE_NAME = "venue_device_name"

export const useDeviceLocation = () => {
  const [deviceLocationState, setDeviceLocationState] = useState(
    createGeolocationFeature(getPersistValue(VENUE_DEVICE_LOCATION_KEY), {
      name: "Your Location",
    })
  )

  const { deviceLocation, locationName } = useQuery()

  useEffect(() => {
    if (deviceLocation && isLatLngQueryString(deviceLocation)) {
      setPersistValue(VENUE_DEVICE_LOCATION_KEY, deviceLocation)
      setDeviceLocationState(
        createGeolocationFeature(getPersistValue(VENUE_DEVICE_LOCATION_KEY), {
          name: "Your Location",
        })
      )
    }
    //TODO finding a better position for setPersistValue VENUE_DEVICE_NAME
    if (locationName) setPersistValue(VENUE_DEVICE_NAME, locationName)
  }, [deviceLocation, locationName])

  return {
    deviceLocation: deviceLocationState,
  }
}
